import { api } from './client.js';

const unwrap = (resp) => resp.data?.data;

// ── Advanced Time Tracking (/time) ────────────────────────────────────
export const timeApi = {
  // work schedules
  listSchedules: (params) => api.get('/time/schedules', { params }).then(unwrap),
  getSchedule: (id) => api.get(`/time/schedules/${id}`).then(unwrap),
  createSchedule: (payload) => api.post('/time/schedules', payload).then(unwrap),
  updateSchedule: (id, patch) => api.patch(`/time/schedules/${id}`, patch).then(unwrap),
  deleteSchedule: (id) => api.delete(`/time/schedules/${id}`).then(unwrap),

  // schedule assignment
  listAssignments: (params) => api.get('/time/assignments', { params }).then(unwrap),
  assignSchedule: (payload) => api.post('/time/assignments', payload).then(unwrap),
  unassignSchedule: (id) => api.delete(`/time/assignments/${id}`).then(unwrap),

  // shifts
  listShifts: (params) => api.get('/time/shifts', { params }).then(unwrap),
  getShift: (id) => api.get(`/time/shifts/${id}`).then(unwrap),
  createShift: (payload) => api.post('/time/shifts', payload).then(unwrap),
  updateShift: (id, patch) => api.patch(`/time/shifts/${id}`, patch).then(unwrap),
  deleteShift: (id) => api.delete(`/time/shifts/${id}`).then(unwrap),

  // timesheets + entries (self-service for the owning employee)
  listTimesheets: (params) => api.get('/time/timesheets', { params }).then(unwrap),
  getTimesheet: (id) => api.get(`/time/timesheets/${id}`).then(unwrap),
  createTimesheet: (payload) => api.post('/time/timesheets', payload).then(unwrap),
  addEntry: (timesheetId, payload) => api.post(`/time/timesheets/${timesheetId}/entries`, payload).then(unwrap),
  updateEntry: (id, patch) => api.patch(`/time/entries/${id}`, patch).then(unwrap),
  removeEntry: (id) => api.delete(`/time/entries/${id}`).then(unwrap),
  submitTimesheet: (id) => api.put(`/time/timesheets/${id}/submit`).then(unwrap),
  approveTimesheet: (id, payload) => api.put(`/time/timesheets/${id}/approve`, payload || {}).then(unwrap),
  rejectTimesheet: (id, payload) => api.put(`/time/timesheets/${id}/reject`, payload || {}).then(unwrap),
};
